(() => {
  const qs=(s,c=document)=>c.querySelector(s), qsa=(s,c=document)=>[...c.querySelectorAll(s)];
  const header=qs('[data-header]');
  const mobilePanel=qs('[data-mobile-panel]');
  const body=document.body;

  // Announcement multi-message auto rotation
  qsa('[data-announcement]').forEach(bar=>{const items=qsa('[data-announcement-item]',bar),dots=qsa('[data-announcement-dot]',bar); if(items.length>1){let i=0; const show=n=>{i=(n+items.length)%items.length;items.forEach((x,j)=>x.classList.toggle('active',j===i));dots.forEach((x,j)=>x.classList.toggle('active',j===i))}; dots.forEach((d,j)=>d.addEventListener('click',()=>show(j))); setInterval(()=>show(i+1),Number(bar.dataset.interval)||4000)}});

  // Hero slider with autoplay, controls and progress
  qsa('[data-hero-slider]').forEach(slider=>{const slides=qsa('[data-hero-slide]',slider),dots=qsa('[data-hero-dot]',slider),dur=Number(slider.dataset.autoplay)||6000; if(slides.length>1){let i=0,timer;const progress=qs('[data-hero-progress]',slider);const show=n=>{i=(n+slides.length)%slides.length;slides.forEach((s,j)=>s.classList.toggle('is-active',j===i));dots.forEach((d,j)=>d.classList.toggle('active',j===i));if(progress){progress.style.setProperty('--hero-duration',dur+'ms');progress.classList.remove('run');void progress.offsetWidth;progress.classList.add('run')}};const next=()=>show(i+1);qs('[data-hero-next]',slider)?.addEventListener('click',()=>{next();restart()});qs('[data-hero-prev]',slider)?.addEventListener('click',()=>{show(i-1);restart()});dots.forEach((d,j)=>d.addEventListener('click',()=>{show(j);restart()}));const restart=()=>{clearInterval(timer);timer=setInterval(next,dur)};show(0);restart();slider.addEventListener('mouseenter',()=>clearInterval(timer));slider.addEventListener('mouseleave',restart)}});

  // Featured products horizontal slider
  qsa('[data-featured-products]').forEach(sec=>{const track=qs('[data-featured-track]',sec);if(!track)return;const step=()=>Math.max(track.clientWidth*.25,260);qs('[data-featured-next]',sec)?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));qs('[data-featured-prev]',sec)?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));const bar=qs('[data-featured-progress]',sec);const update=()=>{if(bar){const max=track.scrollWidth-track.clientWidth;bar.style.width=(max?Math.max(12,track.scrollLeft/max*75+25):100)+'%'}};track.addEventListener('scroll',update,{passive:true});update()});

  // Automatic Instagram feed (Behold JSON feed)
  qsa('[data-instagram-feed]').forEach(section=>{
    const url=section.dataset.feedUrl;
    const grid=qs('[data-instagram-grid]',section);
    const status=qs('[data-instagram-status]',section);
    if(!url || !grid) return;
    const limit=Math.max(1,Number(section.dataset.limit)||6);
    const refresh=Math.max(300000,Number(section.dataset.refresh)||900000);
    const showCaption=section.dataset.showCaption==='true';
    const showType=section.dataset.showType==='true';
    let busy=false;

    const escapeHtml=value=>String(value||'').replace(/[&<>'\"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','\"':'&quot;'}[c]));
    const imageFor=post=>post?.sizes?.medium?.mediaUrl||post?.sizes?.large?.mediaUrl||post?.thumbnailUrl||post?.mediaUrl||post?.children?.[0]?.sizes?.medium?.mediaUrl||'';
    const typeLabel=post=>post?.isReel?'REEL':post?.mediaType==='VIDEO'?'VIDEO':post?.mediaType==='CAROUSEL_ALBUM'?'CAROUSEL':'POST';

    const render=feed=>{
      const posts=Array.isArray(feed?.posts)?feed.posts.slice(0,limit):[];
      if(!posts.length) throw new Error('No Instagram posts returned');
      grid.innerHTML=posts.map(post=>{
        const img=imageFor(post);
        if(!img || !post.permalink) return '';
        const caption=showCaption?(post.prunedCaption||post.caption||''):'';
        const type=typeLabel(post);
        return `<a class="social-image reveal in-view" href="${escapeHtml(post.permalink)}" target="_blank" rel="noopener noreferrer">
          <img src="${escapeHtml(img)}" alt="${escapeHtml(post.altText||caption||'Notes Club on Instagram')}" loading="lazy" decoding="async">
          ${showType && (post.isReel || post.mediaType==='VIDEO')?`<span class="instagram-reel-badge">${escapeHtml(type)}</span>`:''}
          <span class="instagram-overlay" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg></span>
          ${caption?`<span class="instagram-meta"><span class="instagram-caption">${escapeHtml(caption)}</span></span>`:''}
        </a>`;
      }).join('');
      grid.dataset.count=posts.length;
      qsa('.reveal',grid).forEach(el=>observer?.observe(el));
      if(status) status.textContent='';
    };

    const load=async()=>{
      if(busy) return; busy=true;
      try{
        const joiner=url.includes('?')?'&':'?';
        const response=await fetch(url+joiner+'_nc='+Date.now(),{headers:{Accept:'application/json'},cache:'no-store'});
        if(!response.ok) throw new Error('Instagram feed request failed');
        const feed=await response.json();
        render(feed);
      }catch(error){
        if(status) status.textContent='Instagram feed temporarily unavailable. Showing your fallback gallery.';
      }finally{busy=false;}
    };
    load();
    setInterval(load,refresh);
  });

  // Collection sort/view/filter drawer
  qsa('[data-sort-select]').forEach(select=>select.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',select.value);location.href=u.toString()}));
  qsa('[data-filter-open]').forEach(b=>b.addEventListener('click',()=>{const p=qs('[data-filter-panel]');if(p){p.hidden=false;requestAnimationFrame(()=>p.classList.add('open'));body.classList.add('no-scroll')}}));
  qsa('[data-filter-close]').forEach(b=>b.addEventListener('click',()=>{const p=qs('[data-filter-panel]');if(p){p.classList.remove('open');p.hidden=true;body.classList.remove('no-scroll')}}));
  qsa('[data-grid-cols]').forEach(b=>b.addEventListener('click',()=>{const g=qs('[data-product-grid]');if(!g)return;qsa('[data-grid-cols]').forEach(x=>x.classList.remove('active'));b.classList.add('active');g.classList.toggle('cols-3',b.dataset.gridCols==='3');}));
  qsa('[data-variant-picker]').forEach(p=>qsa('[data-variant-id]',p).forEach(btn=>btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();const card=btn.closest('[data-product-card]'),input=qs('.quick-add-form input[name=id]',card);qsa('.variant-pill',p).forEach(x=>x.classList.remove('selected'));btn.classList.add('selected');if(input)input.value=btn.dataset.variantId;})));


  const onScroll=()=>header?.classList.toggle('is-scrolled',window.scrollY>30);
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  qsa('[data-mobile-menu]').forEach(b=>b.addEventListener('click',()=>{mobilePanel?.classList.add('open');body.classList.add('no-scroll')}));
  qsa('[data-mobile-close]').forEach(b=>b.addEventListener('click',()=>{mobilePanel?.classList.remove('open');body.classList.remove('no-scroll')}));

  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in-view');observer.unobserve(e.target)}}),{threshold:.12});
  qsa('.reveal').forEach(el=>observer.observe(el));

  /* AJAX cart: product forms + quick add */
  const money = cents => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const fmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : undefined;
      return fmt ? window.Shopify.formatMoney(cents, fmt) : window.Shopify.formatMoney(cents);
    }
    return (Number(cents || 0) / 100).toFixed(2);
  };

  const escapeHtml = value => String(value ?? '').replace(/[&<>\"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;',"'":'&#39;'}[c]));
  const shopRoot = () => window.Shopify?.routes?.root || '/';

  const getCart = async () => {
    const response = await fetch(shopRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Unable to load cart.');
    return response.json();
  };

  const updateCartCount = cart => {
    qsa('.cart-count, [data-cart-count], [data-cart-count-bubble]').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-hidden', cart.item_count === 0);
    });
  };

  const renderCart = cart => {
    const drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    const box = qs('[data-cart-items]', drawer);
    const total = qs('[data-cart-total]', drawer);
    if (!box) return;

    if (!cart.items.length) {
      box.innerHTML = '<div class="drawer-empty"><h4>Your cart is empty.</h4><p>Discover something you\'ll love.</p></div>';
    } else {
      box.innerHTML = cart.items.map((item, index) => {
        const line = index + 1;
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
        return `<div class="drawer-item" data-cart-item data-line="${line}">
          <div class="drawer-item-image">${image}</div>
          <div class="drawer-item-info">
            <div class="drawer-item-top">
              <div><h4>${escapeHtml(item.product_title)}</h4>${variant ? `<span class="drawer-item-variant">${escapeHtml(variant)}</span>` : ''}</div>
              <button type="button" class="drawer-remove" data-remove-line="${line}" aria-label="Remove item">×</button>
            </div>
            <div class="drawer-item-bottom">
              <div class="drawer-quantity">
                <button type="button" data-quantity-minus-line="${line}">−</button>
                <span data-line-quantity>${item.quantity}</span>
                <button type="button" data-quantity-plus-line="${line}">+</button>
              </div>
              <strong class="drawer-item-price">${money(item.final_line_price)}</strong>
            </div>
          </div>
        </div>`;
      }).join('');
    }
    if (total) total.textContent = money(cart.total_price);
    qsa('[data-cart-count]', drawer).forEach(el => el.textContent = cart.item_count);
    updateCartCount(cart);
  };

  const refreshCart = async () => {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  };

  const openDrawer = async () => {
    const drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    try { await refreshCart(); } catch (e) { console.error('Cart drawer refresh failed:', e); }
    drawer.hidden = false;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('no-scroll');
  };

  const closeDrawer = () => {
    const drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('no-scroll');
    setTimeout(() => { if (!drawer.classList.contains('open')) drawer.hidden = true; }, 300);
  };

  const updateLine = async (line, quantity) => {
    const response = await fetch(shopRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!response.ok) throw new Error('Unable to update cart.');
    const cart = await response.json();
    renderCart(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  };

  const changeLine = async (line, delta) => {
    const cart = await getCart();
    const item = cart.items[line - 1];
    if (!item) return;
    await updateLine(line, Math.max(0, item.quantity + delta));
  };

  /* Catch ALL Shopify product forms, including main product form and quick add. */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const button = qs('[data-add-to-cart], .product-submit, button[type="submit"]', form);
    const text = button && qs('[data-add-text]', button);
    const original = text ? text.textContent : (button ? button.innerHTML : 'ADD TO CART');
    if (button) { button.disabled = true; if (text) text.textContent = 'ADDING...'; else button.innerHTML = 'ADDING...'; }

    try {
      const response = await fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add product.');
      const cart = await refreshCart();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      openDrawer();
      if (text) text.textContent = 'ADDED ✓'; else if (button) button.innerHTML = 'ADDED ✓';
      setTimeout(() => { if (text) text.textContent = original; else if (button) button.innerHTML = original; }, 1400);
    } catch (error) {
      console.error('Add to cart failed:', error);
      if (text) text.textContent = 'TRY AGAIN'; else if (button) button.innerHTML = 'TRY AGAIN';
      setTimeout(() => { if (text) text.textContent = original; else if (button) button.innerHTML = original; }, 1600);
    } finally {
      if (button) button.disabled = false;
    }
  });

  /* Header/cart buttons */
  document.addEventListener('click', e => {
    const trigger = e.target.closest('.cart-trigger, [data-open-cart], .cart-toggle, .header-cart');
    if (trigger) { e.preventDefault(); openDrawer(); return; }

    const close = e.target.closest('[data-close-cart]');
    if (close) { e.preventDefault(); closeDrawer(); return; }

    const remove = e.target.closest('[data-remove-line]');
    if (remove) {
      const line = Number(remove.dataset.removeLine);
      updateLine(line, 0).catch(err => console.error(err));
      return;
    }

    const minus = e.target.closest('[data-quantity-minus-line]');
    if (minus) {
      changeLine(Number(minus.dataset.quantityMinusLine), -1).catch(err => console.error(err));
      return;
    }

    const plus = e.target.closest('[data-quantity-plus-line]');
    if (plus) {
      changeLine(Number(plus.dataset.quantityPlusLine), 1).catch(err => console.error(err));
      return;
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Initial cart count */
  getCart().then(updateCartCount).catch(() => {});
})();

